import React from 'react';
export function WelcomeSection() {
  return <section className="max-w-lg mx-auto px-4 pt-8 pb-6 animate-fade-in" data-id="element-145">
      <div className="text-center" data-id="element-146">
        <h1 className="text-2xl font-bold text-deep-cocoa mb-2" data-id="element-147">
          ¡Ya casi es tuyo! 🎉
        </h1>
        <p className="text-base text-deep-cocoa/80 mb-3" data-id="element-148">
          Estás a un paso de comenzar a ganar dinero con TikTok Shop
        </p>
        <p className="text-sm text-deep-cocoa/60" data-id="element-149">
          Respira tranquila, tu pago es 100% seguro y recibirás acceso
          inmediato.
        </p>
      </div>
    </section>;
}